export class LoginData {
    access_token: string;
    expires_in: string;
    refresh_token: string;
    token_type: string;
    user_name: string;
    expire_date: Date;
    password:string;
    newPassword:string;
}
